import { render, staticRenderFns } from "./QuerySortDropdown.vue?vue&type=template&id=533dafb6&scoped=true"
import script from "./QuerySortDropdown.vue?vue&type=script&lang=js"
export * from "./QuerySortDropdown.vue?vue&type=script&lang=js"
import style0 from "./QuerySortDropdown.vue?vue&type=style&index=0&id=533dafb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533dafb6",
  null
  
)

export default component.exports